
export const checkIsMobile = (uNavigator) => {
  let isMobile = true
  const uA = uNavigator.userAgent

  if (!/iP(ad|od|hone)/i.test(uA)) {
    if (/WebKit/i.test(uA)) {
      isMobile = false
    } else {
      isMobile = uNavigator.userAgentData.mobile
    }
  }
  return isMobile
}

export const capitalizeFirstLetter = (string) => {
  return string.charAt(1).toUpperCase() + string.slice(2)
}

export const scrollElement = (ref, item) => {
  if (item) {
    const currentPosition = item.offsetTop
    if (currentPosition > window.innerHeight) {
      ref.current.getScrollElement().scrollTop = currentPosition - 300
    }
  }
}

export const toggleFullscreen = () => {
  if (
    !document.fullscreenElement &&
    /* alternative standard method */ !document.mozFullScreenElement &&
    !document.webkitFullscreenElement
  ) {
    // current working methods
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen()
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen()
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen(
        Element.ALLOW_KEYBOARD_INPUT
      )
    }
  } else {
    if (document.cancelFullScreen) {
      document.cancelFullScreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen()
    }
  }
}
